import { c as _c } from "react/compiler-runtime";
import { Button } from "@repo/ui/button";
import { Overline } from "@repo/ui/overline";
import { cn } from "@repo/ui/utils";
import { ActionLink } from "@/components/common/actions/actions.component";
import { RichTextCondensed } from "@/components/common/rich-text/rich-text-condensed.component";
import { getI18nString, getI18nValue } from "@/lib/utils";
import type { MarketingPopupData } from "./marketing-popup.types";
interface MarketingPopupContentProps {
  popup: MarketingPopupData;
  headlineClassName?: string;
  className?: string;
  /** Fires before the CTA navigates, so the modal can record popup_click. */
  onCtaClick?: () => void;
}
export function MarketingPopupContent(t0) {
  const $ = _c(24);
  const {
    popup,
    headlineClassName,
    className,
    onCtaClick
  } = t0;
  let t1;
  if ($[0] !== popup.overline) {
    t1 = getI18nString(popup.overline);
    $[0] = popup.overline;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const overline = t1;
  let t2;
  if ($[2] !== popup.headline) {
    t2 = getI18nString(popup.headline);
    $[2] = popup.headline;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const headline = t2;
  let t3;
  if ($[4] !== popup.bodyCopy) {
    t3 = getI18nValue(popup.bodyCopy);
    $[4] = popup.bodyCopy;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const bodyCopy = t3;
  let t4;
  if ($[6] !== className) {
    t4 = cn("flex flex-col gap-4", className);
    $[6] = className;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== overline) {
    t5 = overline && <Overline variant="muted">{overline}</Overline>;
    $[8] = overline;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== headline || $[11] !== headlineClassName) {
    t6 = headline && <h3 className={cn("typography-mobile-heading-h4 tablet:typography-desktop-heading-h4 text-text-primary", headlineClassName)}>{headline}</h3>;
    $[10] = headline;
    $[11] = headlineClassName;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== bodyCopy) {
    t7 = bodyCopy ? <RichTextCondensed richText={bodyCopy} as="body-tablet" className="text-text-secondary" /> : null;
    $[13] = bodyCopy;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== onCtaClick || $[16] !== popup.action) {
    t8 = popup.action && popup.action.to && <ActionLink actionTo={popup.action.to} className="mt-2 self-start" onClick={onCtaClick}><Button variant="blue-filled" asChild={true}><span>{getI18nString(popup.action.text, "Learn more")}</span></Button></ActionLink>;
    $[15] = onCtaClick;
    $[16] = popup.action;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t9 = <div className={t4}>{t5}{t6}{t7}{t8}</div>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}